import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { UserRole } from '../types';
import { canAccessRoute } from '../utils/routeAccess';
import CenteredLoader from './CenteredLoader';

interface RoleRouteProps {
  /** When omitted, uses RESTRICTED_ROUTE_ROLES for current path. */
  roles?: UserRole[];
  children: React.ReactNode;
}

/**
 * Redirects authenticated users without nav access to /dashboard (not login).
 */
const RoleRoute: React.FC<RoleRouteProps> = ({ roles, children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <CenteredLoader size={28} />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const allowed = roles ? roles.includes(user.role) : canAccessRoute(user.role, location.pathname);
  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RoleRoute;
